import { Component, Injector, Input, OnInit } from '@angular/core';
import { PageBase } from '../shared/library/page.base';

@Component({
    selector: 'cp-loading-button',
    templateUrl: './loadingbutton.component.html',
    styleUrls: ['./loadingbutton.component.css'],
    standalone: false
})
export class LoadingButtonComponent extends PageBase implements OnInit {

  @Input() hasNext: boolean;

  constructor(public objInjector: Injector) {
    super(objInjector);
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  onReceiveLiterals(): void {
  }

}
